import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const Navigation: React.FC = () => {
  const location = useLocation();
  return (
    <nav className="bg-gray-800 bg-opacity-60 backdrop-blur-[3px] py-3 px-4 z-10 text-white sticky top-0 overflow-hidden w-full">
      <div className="container mx-auto flex items-center justify-center relative">
        <NavLink
          to="/"
          aria-label="PWC Profiles - Home"
          className="hidden lg:block absolute left-4 lg:left-6 text-white hover:text-blue-400 text-lg font-bold"
        >
          <svg
            className="h-6 w-auto md:h-8"
            viewBox="0 0 161.28018 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M 0,0 19.199706,48 H 35.52012 L 27.840534,28.800295 H 49.919529 L 38.39941,0 Z M 54.719825,0 64.320414,23.999999 73.919529,0 Z M 87.360652,0 96.959766,23.999999 106.56035,0 Z m 35.520118,0 -19.20118,48 h 38.40088 l 5.76007,-14.39941 h -22.08047 l 7.68398,-19.20118 h 22.07607 L 161.28018,0 Z M 80.640838,23.999999 71.040236,48 h 19.199693 z"
            />
          </svg>
        </NavLink>
        <div className="flex justify-center items-center w-full">
          <ul className="flex space-x-3 sm:space-x-6 md:space-x-8 lg:space-x-10 text-center text-xs sm:text-sm md:text-base">
            <li className="whitespace-nowrap">
              <NavLink
                to="/kemper"
                className={({ isActive }) =>
                  isActive ? "text-blue-400 font-semibold" : "text-white hover:text-blue-400"
                }
              >
                <span className="block lg:hidden">Kemper</span>
                <span className="hidden lg:block">Kemper Profiles</span>
              </NavLink>
            </li>

            <li className="whitespace-nowrap">
              <NavLink
                to="/tonex"
                className={({ isActive }) =>
                  isActive ? "text-blue-400 font-semibold" : "text-white hover:text-blue-400"
                }
              >
                <span className="block lg:hidden">Tonex</span>
                <span className="hidden lg:block">Tonex Models</span>
              </NavLink>
            </li>
            <li className="whitespace-nowrap">
              <NavLink
                to="/nam"
                className={({ isActive }) =>
                  isActive ? "text-blue-400 font-semibold" : "text-white hover:text-blue-400"
                }
              >
                <span className="block lg:hidden">NAM</span>
                <span className="hidden lg:block">Neural Amp Modeler</span>
              </NavLink>
            </li>
            <li className="whitespace-nowrap">
              <NavLink
                to="/ir"
                className={() => {
                  const isIrActive =
                    location.pathname === "/ir" ||
                    location.pathname === "/cab-ir" ||
                    location.pathname === "/reverb-ir";
                  return isIrActive ? "text-blue-400 font-semibold" : "text-white hover:text-blue-400";
                }}
              >
                <span className="block lg:hidden">IRs</span>
                <span className="hidden lg:block">Impulse Responses</span>
              </NavLink>
            </li>
            <li className="whitespace-nowrap">
              <NavLink
                to="/plugins"
                className={({ isActive }) =>
                  isActive
                    ? "text-blue-400 font-semibold flex items-center gap-1.5"
                    : "text-white hover:text-blue-400 flex items-center gap-1.5"
                }
              >
                <span>Plugin</span>
                <span className="px-1.5 py-0.5 text-[9px] font-extrabold uppercase bg-gradient-to-r from-cyan-400 to-blue-500 text-gray-950 rounded-full leading-none shadow-[0_0_10px_rgba(34,211,238,0.5)] animate-pulse">
                  NEW
                </span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
